/**
 * Product Highlights — Header animation
 *
 * Hace dos cosas:
 *   1. Envuelve cada palabra del heading en un <span class="word"> con su índice.
 *   2. Usa IntersectionObserver para añadir la clase .is-visible cuando la
 *      sección entra en el viewport, disparando las animaciones del CSS.
 */
(function () {
  'use strict';

  var SELECTOR = '.product-highlights[data-enable-header-animation]';

  function wrapWords(headingEl) {
    if (!headingEl || headingEl.dataset.wordsWrapped === 'true') return;

    var text = headingEl.textContent.trim();
    if (!text) return;

    var words = text.split(/\s+/);
    var html = words
      .map(function (word, i) {
        return (
          '<span class="word" style="--word-index: ' +
          i +
          '">' +
          word +
          '</span>'
        );
      })
      .join(' ');

    headingEl.innerHTML = html;
    headingEl.dataset.wordsWrapped = 'true';
  }

  function init(section) {
    var heading = section.querySelector('.ph-header__heading');
    if (heading) {
      wrapWords(heading);
    }

    if (!('IntersectionObserver' in window)) {
      // Fallback: muestra todo sin animar
      section.classList.add('is-visible');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
    );

    observer.observe(section);
  }

  function bootstrap() {
    document.querySelectorAll(SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  // Soporte para el editor del theme (cuando se agrega/edita la sección)
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector(SELECTOR);
    if (section) init(section);
  });
})();